<template>
	<div class="content-zsy">
		<div class="widget-location">
			<h3>회원정보 수정</h3>
		</div>
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0" class="">
			<div class="member-info">
				<h4>필수정보 입력</h4>
				<!--用户id-->
				<el-row style="padding: 10px 0;">
					<el-col :span="isMobile?8:4">
						<div class="from-title">아이디</div>
					</el-col>
					<el-col :span="isMobile?16:20">
						<span style="font-weight: bold; margin-right: 15px;">{{ruleForm.username}}</span>
						<el-button v-if="isKakaoAccount" type="warning" size="mini" @click="dialogVisible = true" style="background-color: #FEE500; border-color: #FEE500; color: #191919; font-weight: bold; margin-left: 10px;">기존 계정 연동 (계정 찾기)</el-button>
					</el-col>
				</el-row>
				<!--姓名-->
				<el-row style="padding: 10px 0 20px;">
					<el-col :span="isMobile?8:4">
						<div class="from-title">이름</div>
					</el-col>
					<el-col :span="isMobile?16:20">
						{{ruleForm.nickname}}
					</el-col>
				</el-row>
				<!--新密码-->
				<el-row>
					<el-col :span="isMobile?8:4">
						<div class="from-title">새로운 비밀번호</div>
					</el-col>
					<el-col :span="isMobile?16:20">
						<el-form-item  prop="password">
							<el-input v-model="ruleForm.password" type="password" style="width: 270px;" ></el-input>
						</el-form-item>  
					</el-col>
				</el-row>
				<!--验证密码-->
				<el-row>
					<el-col :span="isMobile?8:4">
						<div class="from-title">확인용 비밀번호</div>
					</el-col>
					<el-col :span="isMobile?16:20">
						<el-form-item  prop="repassword">
							<el-input v-model="ruleForm.repassword" type="password" style="width: 270px;" ></el-input>
						</el-form-item>  
					</el-col>
				</el-row>
				<!--移动电话 手机-->
				<el-row>
					<el-col :span="isMobile?8:4">
						<div class="from-title">휴대폰번호 <span class="required-addon">*</span></div>
					</el-col>
					<el-col :span="isMobile?16:20" style="display: flex;">
					
						<el-form-item  prop="areacode">
							<el-select style="width: 80px;" v-model="ruleForm.areacode"  placeholder="">
								<el-option v-for="item in areacode_options" :label="item.label" :value="item.value" :key="item.value"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item  prop="mobile">
							<el-input v-model="ruleForm.mobile" type="number" style="width: 190px;" ></el-input>
						</el-form-item>   
				
					</el-col>
				</el-row>
				<!--EMAIL-->
				<el-row>
					<el-col :span="isMobile?8:4">
				 		<div class="from-title">메일 <span class="required-addon">*</span></div>
					</el-col>
					<el-col :span="isMobile?16:20">
						<el-form-item  prop="email">
							<el-input v-model="ruleForm.email" style="width: 270px;" ></el-input>
							<div class="help-block">아이디 및 비밀번호 찾기외 각종 안내를 메일로 발송하오니 자주쓰는 메일로 입력해 주세요.</div>
						</el-form-item>  
					</el-col>
				</el-row>
	
			</div>
			<div class="member-info">
				<h4>추가정보 입력</h4>
				
				<!--个人清关唯一代码-->
				<el-row>
					<el-col :span="isMobile?8:4">
						<div class="from-title">개인통관고유부호 </div>
					</el-col>
					<el-col :span="isMobile?16:20">
						<el-form-item  prop="customs_info">
							<el-input v-model="ruleForm.customs_info" style="width: 270px;" ></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<!--性别-->
				<el-row>
					<el-col :span="isMobile?8:4">
						<div class="from-title">성별 </div>
					</el-col>
					<el-col :span="isMobile?16:20">
						<el-form-item  prop="gender">
							<el-radio-group v-model="ruleForm.gender">
								<el-radio :label="1" >남자</el-radio>
								<el-radio :label="0" >여자</el-radio>
							</el-radio-group>
						</el-form-item>  
					</el-col>
				</el-row>
				<!--生日-->
				<el-row>
				 <el-col :span="isMobile?8:4">
						<div class="from-title">생년월일 </div>
				 </el-col>
				 <el-col :span="isMobile?16:20">
						<el-form-item prop="birthday">
							<el-date-picker type="date" placeholder="날짜 선택" v-model="ruleForm.birthday" value-format="yyyy-MM-dd" style="width: 270px;"></el-date-picker>
						</el-form-item>
				 </el-col>
				</el-row>
			</div>
			<div class="member-info" v-if="ruleForm.identity==2">
				<h4>사업자정보</h4>
				<el-row style="padding: 10px 0;">
					<el-col :span="isMobile?8:4">
						<div class="from-title">상호명</div>
					</el-col>
					<el-col :span="isMobile?16:20">
						{{ruleForm.biz_company}}
					</el-col>
				</el-row>
				<el-row style="padding: 10px 0;">
					<el-col :span="isMobile?8:4">
						<div class="from-title">사업자등록번호</div>
					</el-col>
					<el-col :span="isMobile?16:20">
						{{ruleForm.biz_number}}
					</el-col>
				</el-row>
				<el-row style="padding: 10px 0;" >
					<el-col :span="isMobile?8:4">
						<div class="from-title">대표자명</div>
					</el-col>
					<el-col :span="isMobile?16:20">
						{{ruleForm.biz_ceo}}
					</el-col>
				</el-row>
				<el-row style="padding: 10px 0;">
					<el-col :span="isMobile?8:4">
						<div class="from-title">사업장연락처</div>
					</el-col>
					<el-col :span="isMobile?16:20">
						{{ruleForm.biz_tel}}
					</el-col>
				</el-row>
				<el-row style="padding: 10px 0;">
					<el-col :span="isMobile?8:4">
						<div class="from-title">사업자등록증</div>
					</el-col>
					<el-col :span="isMobile?16:20">
						<a :href="ruleForm.license_url" class="link" target="_blank">이해_사업자등록증명</a>
					</el-col>
				</el-row>
				
				
			</div>	
			
			<div class="member-info" v-if="ruleForm.identity==1">
				<h4>기업 회원 전환</h4>
				<el-row v-if="upgradeInfo && upgradeInfo.status === 0" style="padding: 20px; background-color: #f8f9fa; border-radius: 4px; text-align: center;">
					<i class="el-icon-time" style="font-size: 24px; color: #E6A23C;"></i>
					<p style="margin: 10px 0; font-size: 16px; font-weight: bold;">기업 회원 전환 신청이 심사 중입니다.</p>
					<p style="color: #666; font-size: 14px; margin-bottom: 15px;">관리자가 확인 후 처리될 예정입니다. 잠시만 기다려주세요.</p>
					<el-button type="danger" size="small" @click="cancelUpgrade" :loading="canceling">신청 취소 (撤销申请)</el-button>
				</el-row>
				<el-row v-else style="padding: 10px 0;">
					<el-col :span="24">
						<div v-if="upgradeInfo && upgradeInfo.status === 2" style="margin-bottom: 15px; padding: 10px; background-color: #fef0f0; color: #F56C6C; border-radius: 4px;">
							<i class="el-icon-error"></i> 심사 반려: {{upgradeInfo.remark}}
						</div>
						<p style="margin-bottom: 15px; color: #666;">개인 회원에서 기업 회원으로 전환을 원하시면 아래 버튼을 클릭하여 사업자 정보를 제출해주세요.</p>
						<el-button type="primary" @click="upgradeDialogVisible = true">기업 회원 전환 신청 (申请企业会员)</el-button>
					</el-col>
				</el-row>
			</div>
			
			<el-form-item style="text-align: center;padding:40px 0 10px;">
				<el-button type="primary" @click="submitForm('ruleForm')">수정하기</el-button>
				<el-button @click="onReturn">뒤로</el-button>
			</el-form-item>
		</el-form>

		<!-- 계정 연동 다이얼로그 (계정 찾기) 账户关联对话框（查找账户）-->
		<el-dialog
			title="기존 계정 연동 (계정 찾기)"
			:visible.sync="dialogVisible"
			:width="isMobile ? '90%' : '450px'"
			center
			append-to-body>
			<div style="padding: 10px 0; font-size: 14px; color: #666; line-height: 1.5; text-align: center; margin-bottom: 20px;">
				카카오로 자동 생성된 임시 계정입니다.<br>
				기존에 사용하시던 계정(아이디 또는 이메일)의 비밀번호를 입력하시면,<br>
				현재 카카오 로그인 정보가 기존 계정으로 연동(통합)됩니다.
			</div>
			<el-form :model="linkForm" ref="linkForm" label-position="top">
				<el-form-item label="기존 계정 아이디 또는 이메일">
					<el-input v-model="linkForm.username" placeholder="아이디 또는 이메일을 입력하세요."></el-input>
				</el-form-item>
				<el-form-item label="기존 계정 비밀번호">
					<el-input v-model="linkForm.password" type="password" placeholder="비밀번호를 입력하세요." @keyup.enter.native="submitLinkAccount"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">취소</el-button>
				<el-button type="primary" @click="submitLinkAccount" :loading="linking" style="background-color: #F7941D; border-color: #F7941D;">연동 완료</el-button>
			</span>
		</el-dialog>

		<!-- 기업 회원 전환 다이얼로그 (申请企业会员) -->
		<el-dialog
			title="기업 회원 전환 신청"
			:visible.sync="upgradeDialogVisible"
			:width="isMobile ? '90%' : '500px'"
			center
			append-to-body>
			<el-form :model="upgradeForm" ref="upgradeForm" label-position="top">
				<el-form-item label="상호명 (기업명)" required>
					<el-input v-model="upgradeForm.company_name" placeholder="상호명을 입력하세요."></el-input>
				</el-form-item>
				<el-form-item label="사업자등록번호" required>
					<el-input v-model="upgradeForm.company_no" placeholder="사업자등록번호를 입력하세요."></el-input>
				</el-form-item>
				<el-form-item label="대표자 성명" required>
					<el-input v-model="upgradeForm.ceo_name" placeholder="대표자 성명을 입력하세요."></el-input>
				</el-form-item>
				<el-form-item label="사업자등록증 이미지" required>
					<el-upload
					  :action="update_url+'/common/upload'"
					  :before-upload="beforeUpgradeUpload"
					  :on-preview="previewUpgradeLicense"
					  :on-remove="removeUpgradeLicense"
					  :on-success="handleUpgradeSuccess"
					  :on-progress="handleUpgradeProgress"
					  :on-error="handleUpgradeError"
					  :limit="1"
					  :on-exceed="handleUpgradeExceed"
					  :file-list="upgradeFileList"
					  :show-file-list="false">
					  <el-button size="small" type="primary" :loading="upgradeIsUploading">파일 선택</el-button>
					  <div slot="tip" class="el-upload__tip">jpg/png 파일만 업로드 가능하며, 최대 10MB까지 가능합니다</div>
					</el-upload>
					<el-progress v-if="upgradeIsUploading" :percentage="upgradeUploadPercent" style="width: 100%; margin-top: 10px;"></el-progress>
					<div class="license-thumbnail" v-if="upgradeForm.license_image">
						<div class="thumbnail-wrapper">
							<img :src="upgradeLicenseFullUrl" alt="사업자등록증" @click="previewUpgradeLicense" />
							<div class="thumbnail-overlay" @click="removeUpgradeLicense">
								<i class="el-icon-delete"></i>
								<span>삭제</span>
							</div>
						</div>
					</div>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="upgradeDialogVisible = false">취소</el-button>
				<el-button type="primary" @click="submitUpgrade" :loading="upgrading">신청하기</el-button>
			</span>
		</el-dialog>
		
	</div>
</template>

<script>
	import request from '@/utils/request';
	import { safePush } from '@/utils/router';
	import Constants from '@/constants';
	export default {
		data() {
			return {
				dialogVisible: false,
				linking: false,
				linkForm: {
					username: '',
					password: '',
				},
				upgradeDialogVisible: false,
				upgrading: false,
				canceling: false,
				upgradeInfo: null,
				upgradeForm: {
					company_name: '',
					company_no: '',
					ceo_name: '',
					license_image: ''
				},
				update_url: "",
				upgradeFileList: [],
				upgradeIsUploading: false,
				upgradeUploadPercent: 0,
				ruleForm: {
					  //service:'동의안함',
					  //information:'동의안함',
					  //username: '',
					  //nickname:'',
					  password:'',
					  repassword:'',
					  mobile:'',	  
					  areacode:'',
					  email:'',
					  //recommend_id:'',
					  customs_info:'',
					  gender:'',
					  birthday:'',
					  
					  //business:'',
					  // identity:'',
					  // biz_company:'',
					  // biz_number:'',
					  // biz_ceo:'',
					  // biz_tel:'',
					  // biz_areacode:'010',
				},
				areacode_options: [
					{
						value: '010',
						label: '010'
					},{
						value: '011',
						label: '011'
					},{
						value: '016',
						label: '016'
					},{
						value: '017',
						label: '017'
					},{
						value: '018',
						label: '018'
					},{
						value: '019',
						label: '019'
					},{
						value: '070',
						label: '070'
					},{
						value: '02',
						label: '02'
					},{
						value: '031',
						label: '031'
					},{
						value: '032',
						label: '032'
					},{
						value: '033',
						label: '033'
					},{
						value: '041',
						label: '041'
					},{
						value: '042',
						label: '042'
					},{
						value: '043',
						label: '043'
					},{
						value: '044',
						label: '044'
					},{
						value: '051',
						label: '051'
					},{
						value: '052',
						label: '052'
					},{
						value: '053',
						label: '053'
					},{
						value: '054',
						label: '054'
					},{
						value: '055',
						label: '055'
					},{
						value: '061',
						label: '061'
					},{
						value: '062',
						label: '062'
					},{
						value: '063',
						label: '063'
					},{
						value: '064',
						label: '064'
					},
				],
				rules: {
				 //  username: [
					// { required: true, message: '请输入用户id', trigger: 'blur' },
					// { min: 4, max: 20, message: '长度在 4 到 20 个字符', trigger: 'blur' }
				 //  ],
				 //  nickname: [
					// { required: true, message: '请输入姓名', trigger: 'blur' }
				 //  ],
				 //  password: [
				 //  	{ required: true, message: '请输入密码' },
					// { min: 4, message: '长度至少 4 个字符', trigger: 'blur' }
				 //  ],
					// repassword: [
					// 	{ validator: (rule, value, callback) => {
					// 		if (value === '') {
					// 		  callback(new Error('请再次输入密码'));
					// 		} else if (value !== this.ruleForm.password) {
					// 		  callback(new Error('两次输入密码不一致!'));
					// 		} else {
					// 		  callback();
					// 		}
					//   }, trigger: 'blur' }
					// ],
					mobile:[
						{ validator: (rule, value, callback) => {
							const regex = /^\d{7,8}$/;		
							if (!regex.test(value)) {
							  callback(new Error('手机格式不正确'));
							} else {
							  callback();
							}
						}, trigger: 'blur' }
					],
					email:[
						{ validator: (rule, value, callback) => {
							const regex = /^(?![-+.])(?![-+.]$)(?<![-+.])[a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;		
							if (!regex.test(value)) {
							  callback(new Error('邮箱格式不正确'));
							} else {
							  callback();
							}
						}, trigger: 'blur' }
					],
						
					
				}
			}
		},
		computed: {
			isMobile() {
				return window.innerWidth <= 768;
			},
			isKakaoAccount() {
				return this.ruleForm.username && this.ruleForm.username.startsWith('kakao_');
			},
			upgradeLicenseFullUrl() {
				if (this.upgradeFileList && this.upgradeFileList.length > 0) {
					return this.upgradeFileList[0].url;
				}
				return this.upgradeForm.license_image;
			}
		},
		mounted() {
			this.update_url = Constants.BASE_URL;
		},
		created() {
			this.getUserInfo()
			this.getUpgradeStatus()
		},
		methods: {
			getUserInfo(){
				console.log("加载")
				request.post('/User/getUserInfo',{}
				).then(res => {
					console.log(res,"列表")
					if(res.code ==1){
						this.ruleForm= res.data
					}		
				});
				
				
				
			},
			submitForm(formName) {
				console.log(this.ruleForm.password)
				console.log(this.ruleForm.repassword)
				if(this.ruleForm.repassword!="" || this.ruleForm.password!=""){
					if(this.ruleForm.repassword != this.ruleForm.password){
						alert("두 비밀번호가 일치하지 않습니다.") // 两次输入密码不一致
						return
					}
					if(this.ruleForm.password.length<4){
						alert("비밀번호는 최소 4자 이상이어야 합니다.") // 长度至少 4 个字符
						return
					}
				}
				
				this.$refs[formName].validate((valid) => {
				  if (valid) {
					  request.post('/User/editUserInfo',
					  	this.ruleForm
					  ).then(response => {
						  console.log(response,"")			  
					  	if(response.code ==1){
							alert(response.msg);
							console.log('注册提交成功,稍后审核通过即可登录！');
			
					  	}else{
					  		alert(response.msg)
					  		return
					  	}
					  });
					  
					  
					  console.log(this.ruleForm,"提交")
					
				  } else {
					console.log('error submit!!');
					return false;
				  }
				});
				
			},
			onReturn(){
				safePush(this.$router, '/orderBundle');
			},
			submitLinkAccount() {
				if (!this.linkForm.username || !this.linkForm.password) {
					alert("아이디와 비밀번호를 모두 입력해주세요.");
					return;
				}
				this.linking = true;
				request.post('/User/linkKakaoAccount', this.linkForm)
					.then(res => {
						this.linking = false;
						if (res.code === 1) {
							alert(res.msg || "계정이 성공적으로 연동되었습니다!");
							this.dialogVisible = false;
							
							const userinfo = res.data.userinfo;
							localStorage.setItem('token', userinfo.token);
							localStorage.setItem('nickname', userinfo.nickname);
							
							if (this.$store && this.$store.dispatch) {
								this.$store.dispatch('login', {
									token: userinfo.token,
									nickname: userinfo.nickname,
									user_id: userinfo.id
								});
							}
							
							this.$router.replace('/orderBundle').then(() => {
								window.location.reload();
							});
						} else {
							alert(res.msg || "연동에 실패했습니다.");
						}
					})
					.catch(err => {
						this.linking = false;
						console.error(err);
						alert("서버 오류가 발생했습니다.");
					});
			},
			handleUpgradeSuccess(res, file) {
				this.upgradeIsUploading = false;
				this.upgradeUploadPercent = 0;
				if(res.code == 1){
					this.upgradeFileList = [{name: file.name, url: res.data.fullurl}];
					this.upgradeForm.license_image = res.data.url;
				} else {
					this.$message.error(res.msg || '업로드 실패했습니다.');
				}
			},
			handleUpgradeProgress(event, file, fileList) {
				this.upgradeUploadPercent = Math.floor(event.percent);
			},
			handleUpgradeError(err, file, fileList) {
				this.upgradeIsUploading = false;
				this.upgradeUploadPercent = 0;
				this.$message.error('업로드 실패했습니다. 다시 시도해주세요.');
			},
			handleUpgradeExceed(files, fileList) {
				this.$message.warning(`현재 파일 1개만 선택 가능합니다.`);
			},
			beforeUpgradeUpload(file) {
				this.upgradeIsUploading = true;
				this.upgradeUploadPercent = 0;
				const isPt = (file.type === 'image/jpeg' || file.type === 'image/png');
				const isLt10M = file.size / 1024 / 1024 < 10;
		
				if (!isPt) {
				  this.$message.error('이미지 파일(JPG/PNG)만 업로드 가능합니다!');
				}
				if (!isLt10M) {
				  this.$message.error('파일 크기는 10MB를 초과할 수 없습니다!');
				}
				if (!(isPt && isLt10M)) {
				  this.upgradeIsUploading = false;
				}
				return isPt && isLt10M;
			},
			removeUpgradeLicense() {
				this.upgradeFileList = [];
				this.upgradeForm.license_image = '';
			},
			previewUpgradeLicense() {
				if (this.upgradeLicenseFullUrl) {
					window.open(this.upgradeLicenseFullUrl, '_blank');
				}
			},
			getUpgradeStatus() {
				request.post('/User/getUpgradeStatus').then(res => {
					if (res.code === 1 && res.data.apply) {
						this.upgradeInfo = res.data.apply;
					}
				});
			},
			submitUpgrade() {
				if (!this.upgradeForm.company_name || !this.upgradeForm.company_no || !this.upgradeForm.ceo_name || !this.upgradeForm.license_image) {
					alert("모든 정보를 입력해주세요.");
					return;
				}
				this.upgrading = true;
				request.post('/User/submitUpgrade', this.upgradeForm).then(res => {
					this.upgrading = false;
					if (res.code === 1) {
						alert(res.msg);
						this.upgradeDialogVisible = false;
						this.getUpgradeStatus(); // 刷新状态
					} else {
						alert(res.msg);
					}
				}).catch(() => {
					this.upgrading = false;
					alert("서버 오류가 발생했습니다.");
				});
			},
			cancelUpgrade() {
				if (confirm("정말로 신청을 취소하시겠습니까? ")) {//(确定要撤销申请吗？)
					this.canceling = true;
					request.post('/User/cancelUpgrade').then(res => {
						this.canceling = false;
						if (res.code === 1) {
							alert(res.msg);
							this.getUpgradeStatus(); // 刷新状态
						} else {
							alert(res.msg);
						}
					}).catch(() => {
						this.canceling = false;
					});
				}
			}
		}
		
	}
</script>

<style scoped>
	.widget-location {
	    margin-top: 50px;
	    margin-bottom: 60px;
	    text-align: center;
	}
	.widget-location h3 {
	    padding: 0;
	    margin: 0;
	    font-size: 45px;
	    font-weight: bold;
	    color: var(--frontground-color);
	}
	.member-info h4 {
	    font-size: 24px;
	    font-weight: bold;
	    margin-bottom: 21px;
		padding-bottom: 15px;
		border-bottom: 1px solid #333;
	}
	.from-title{
		/* padding:10px 0; */
		font-weight: bold;
	}
	.required-addon{
		color: var(--main-color);
	}
	.help-block{
		font-size: 15px;
		color: var(--font-color);
	}
	a.link{
		color:#337ab7;
		text-decoration: none;
	}
	
	
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		.content-zsy{
			padding:40px 10px;
		}
		.widget-location h3 {
		    font-size: 30px;
		}
		.member-info h4 {
		    font-size: 14px;
		}
	
	}
	.license-thumbnail {
		margin-top: 15px;
		width: 150px;
		height: 200px;
		border: 1px solid #dcdfe6;
		border-radius: 4px;
		overflow: hidden;
		position: relative;
	}
	.thumbnail-wrapper {
		width: 100%;
		height: 100%;
		position: relative;
	}
	.thumbnail-wrapper img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		cursor: pointer;
	}
	.thumbnail-overlay {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0,0,0,0.5);
		color: #fff;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		opacity: 0;
		transition: opacity 0.3s;
		cursor: pointer;
	}
	.thumbnail-wrapper:hover .thumbnail-overlay {
		opacity: 1;
	}
</style>